var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeWorkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.57143C5.26237 4.57143 6.28571 3.54808 6.28571 2.28571C6.28571 1.02335 5.26237 0 4 0C2.73763 0 1.71429 1.02335 1.71429 2.28571C1.71429 3.54808 2.73763 4.57143 4 4.57143ZM6.33705 11.4286V11.3949C6.33705 10.2632 6.96192 9.27744 7.88545 8.76385C7.71296 8.05875 7.35022 7.40765 6.82842 6.88586C6.07829 6.13571 5.06087 5.71429 4 5.71429C2.93913 5.71429 1.92171 6.13571 1.17158 6.88586C0.421427 7.636 0 8.65342 0 9.71429V10.8571C0 11.1727 0.255838 11.4286 0.571429 11.4286H1.71429L2.22314 15.4994C2.25889 15.7854 2.50198 16 2.79016 16H5.20984C5.49802 16 5.74111 15.7854 5.77686 15.4994L6.28571 11.4286H6.33705ZM11.3451 8.78544C11.1873 8.78544 11.0594 8.91335 11.0594 9.07115V9.81501H12.6738V9.07115C12.6738 8.91335 12.5458 8.78544 12.3881 8.78544H11.3451ZM9.34514 9.07115V9.81501C8.47277 9.81519 7.76562 10.5224 7.76562 11.3949V14.4201C7.76562 15.2926 8.47295 15.9999 9.34546 15.9999H14.3875C15.26 15.9999 15.9673 15.2926 15.9673 14.4201V11.3949C15.9673 10.5225 15.2603 9.81533 14.3881 9.81501V9.07115C14.3881 7.96658 13.4927 7.07115 12.3881 7.07115H11.3451C10.2406 7.07115 9.34514 7.96658 9.34514 9.07115Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeWorkerIcon);
export default __webpack_public_path__ + "static/media/officeWorkerIcon.bed7492c0c0c0f90b23e208e62f5af99.svg";
export { ForwardRef as ReactComponent };